// import { useEffect, useState } from "react";
// import {
//   DateRangePicker,
//   defaultInputRanges,
//   defaultStaticRanges,
//   DateRange,
// } from "react-date-range";
// import "react-date-range/dist/styles.css";
// import "react-date-range/dist/theme/default.css";
// import { useDispatch, useSelector } from "react-redux";
// // import {
// //   setButtonClicked,
// //   setTimeSeries,
// //   setTimeSeries1,
// //   setTimeSeriesDateType,
// // } from "../../../redux/features/dashboardSlice";
// import {
//   setButtonClicked,
//   setTimeSeries,
//   setTimeSeries1,
//   setTimeSeriesDateType,
// } from "../../../../redux/features/dashboardSlice";
// import moment from "moment";
// import {
//   addDays,
//   endOfDay,
//   startOfDay,
//   startOfYear,
//   startOfMonth,
//   endOfMonth,
//   endOfYear,
//   addMonths,
//   subMonths,
//   addYears,
//   startOfWeek,
//   endOfWeek,
//   isSameDay,
//   differenceInCalendarDays,
// } from "date-fns";
// export default function DateRangePickerTransactional({ reduxFunc }) {
//   const resd = useSelector((data) => data?.dashboardReducer);

//   // console.log({ resd });
//   const dispatch = useDispatch();

//   var date = new Date(),
//     y = date.getFullYear(),
//     m = date.getMonth();
//   var firstDay = new Date(y, m, 1);
//   const [state, setState] = useState([
//     {
//       startDate: new Date(resd?.timeSeries?.start),
//       endDate: new Date(resd?.timeSeries?.end),
//       key: "selection",
//     },
//   ]);
//   const onChangee = (item, val) => {
//     if (
//       item.selection.endDate > new Date() &&
//       item.selection.startDate <
//         new Date(moment(new Date()).subtract(6, "months"))
//     ) {
//       // console.log("payload if");
//       setState([
//         {
//           startDate: new Date(moment(new Date()).subtract(6, "months")),
//           endDate: new Date(),
//           key: "selection",
//         },
//       ]);
//       dispatch(setTimeSeriesDateType("Monthly"));
//     } else if (item.selection.endDate > new Date()) {
//       // console.log("payload if 1");
//       var date = moment(new Date());
//       var now = moment(item.selection.startDate);
//       var duration = moment.duration(date.diff(now));
//       var noofDays = duration.asDays();
//       if (noofDays >= 30) dispatch(setTimeSeriesDateType("Monthly"));
//       else dispatch(setTimeSeriesDateType("Daily"));
//       setState([
//         {
//           startDate: item.selection.startDate,
//           endDate: new Date(),
//           key: "selection",
//         },
//       ]);
//     } else if (
//       item.selection.startDate <
//       new Date(moment(new Date()).subtract(6, "months"))
//     ) {
//       // console.log("payload if 2");
//       dispatch(setTimeSeriesDateType("Monthly"));
//       setState([
//         {
//           startDate: new Date(moment(new Date()).subtract(6, "months")),
//           endDate: item.selection.endDate,
//           key: "selection",
//         },
//       ]);
//     } else {
//       var date = moment(item.selection.endDate);
//       var now = moment(item.selection.startDate);
//       var duration = moment.duration(date.diff(now));
//       var noofDays = duration.asDays();
//       if (noofDays >= 30) dispatch(setTimeSeriesDateType("Monthly"));
//       else dispatch(setTimeSeriesDateType("Daily"));
//       setState([item.selection]);
//     }
//   };

//   return (
//     <>
//       <DateRange
//         onChange={(item, val) => onChangee(item, val)}
//         maxDate={new Date()}
//         minDate={new Date(moment(new Date()).subtract(6, "months"))}
//         showSelectionPreview={true}
//         moveRangeOnFirstSelection={false}
//         months={2}
//         ranges={state}
//         direction="horizontal"
//       />
//       <div className="row my-3 px-3">
//         <div className="text-end">
//           <button
//             type="button"
//             onClick={() => {
//               setState([
//                 {
//                   startDate: new Date(moment(firstDay).format("YYYY-MM-DD")),
//                   endDate: new Date(moment(new Date()).format("YYYY-MM-DD")),
//                   key: "selection",
//                 },
//               ]);
//               dispatch(
//                 setTimeSeries({
//                   end: moment(new Date()).format("YYYY-MM-DD"),
//                   start: moment(firstDay).format("YYYY-MM-DD"),
//                   dateType: resd?.timeSeries?.dateType,
//                 })
//               );
//             }}
//             className="btn bg-gradient-secondary m-0 me-2"
//           >
//             Reset
//             <i className="material-icons opacity-10">settings_backup_restore</i>
//           </button>
//           <button
//             type="button"
//             id="datepickerSumbit"
//             onClick={() => {
//               dispatch(setButtonClicked());
//               dispatch(
//                 setTimeSeries({
//                   start: moment(state[0].startDate).format("YYYY-MM-DD"),
//                   end: moment(state[0].endDate).format("YYYY-MM-DD"),
//                   dateType: resd?.timeSeries?.dateType,
//                   buttonClicked: !resd?.timeSeries?.buttonClicked,
//                 })
//               );
//             }}
//             className="btn bg-gradient-primary m-0"
//           >
//             Submit
//             <i className="material-icons opacity-10">arrow_right_alt</i>
//           </button>
//         </div>
//       </div>
//     </>
//   );
// }












import { useEffect, useState } from "react";
import {
  DateRangePicker,
  defaultInputRanges,
  defaultStaticRanges,
  DateRange,
} from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { useDispatch, useSelector } from "react-redux";
// import {
//   setButtonClicked,
//   setTimeSeries,
//   setTimeSeries1,
//   setTimeSeriesDateType,
// } from "../../../redux/features/dashboardSlice";
// import {
//   setButtonClicked,
//   setTimeSeries,
//   setTimeSeries1,
//   setTimeSeriesDateType,
//   setTimeSeriesDateType1
// } from "../../../../redux/features/dashboardSlice";
import { setButtonClicked,  setTimeSeries,
    setTimeSeries1,
    setTimeSeries2,
    setTimeSeriesDateType,
    setTimeSeriesDateType1 } from "../../../redux/features/dashboardSlice";
import moment from "moment";
import {
  addDays,
  endOfDay,
  startOfDay,
  startOfYear,
  startOfMonth,
  endOfMonth,
  endOfYear,
  addMonths,
  subMonths,
  addYears,
  startOfWeek,
  endOfWeek,
  isSameDay,
  differenceInCalendarDays,
} from "date-fns";
export default function DateRangePickerGraph({ reduxFunc }) {
  const resd = useSelector((data) => data?.dashboardReducer);

  // console.log({ resd });
  const dispatch = useDispatch();

  var date = new Date(),
    y = date.getFullYear(),
    m = date.getMonth();
  var firstDay = new Date(y, m, 1);
  const [state, setState] = useState([
    {
      startDate: new Date(resd?.timeSeries2?.start),
      endDate: new Date(resd?.timeSeries2?.end),
      key: "selection",
    },
  ]);
  const onChangee = (item, val) => {
    if (
      item.selection.endDate > new Date() &&
      item.selection.startDate <
        new Date(moment(new Date()).subtract(6, "months"))
    ) {
      // console.log("payload if");
      setState([
        {
          startDate: new Date(moment(new Date()).subtract(6, "months")),
          endDate: new Date(),
          key: "selection",
        },
      ]);
      dispatch(setTimeSeriesDateType1("Monthly"));
    } else if (item.selection.endDate > new Date()) {
      // console.log("payload if 1");
      var date = moment(new Date());
      var now = moment(item.selection.startDate);
      var duration = moment.duration(date.diff(now));
      var noofDays = duration.asDays();
      if (noofDays >= 30) dispatch(setTimeSeriesDateType1("Monthly"));
      else dispatch(setTimeSeriesDateType1("Daily"));
      setState([
        {
          startDate: item.selection.startDate,
          endDate: new Date(),
          key: "selection",
        },
      ]);
    } else if (
      item.selection.startDate <
      new Date(moment(new Date()).subtract(6, "months"))
    ) {
      // console.log("payload if 2");
      dispatch(setTimeSeriesDateType1("Monthly"));
      setState([
        {
          startDate: new Date(moment(new Date()).subtract(6, "months")),
          endDate: item.selection.endDate,
          key: "selection",
        },
      ]);
    } else {
      var date = moment(item.selection.endDate);
      var now = moment(item.selection.startDate);
      var duration = moment.duration(date.diff(now));
      var noofDays = duration.asDays();
      if (noofDays >= 30) dispatch(setTimeSeriesDateType1("Monthly"));
      else dispatch(setTimeSeriesDateType1("Daily"));
      setState([item.selection]);
    }
  };
  return (
    <>
      <DateRange
        onChange={(item, val) => onChangee(item, val)}
        maxDate={new Date(moment(new Date()))}
        minDate={new Date(moment(new Date()).subtract(6, "months"))}
        showSelectionPreview={true}
        moveRangeOnFirstSelection={false}
        months={2}
        ranges={state}
        direction="horizontal"
      />
      <div className="row my-3 px-3">
        <div className="text-end">
          <button
            type="button"
            onClick={() => {
            
              if(resd?.timeSeries2?.dateReset == "1W" ){
              setState([
                {
                  startDate:  new Date(moment(addDays(new Date(), -6)).format(
                        "YYYY-MM-DD"
                      )),
                  endDate:  new Date(moment().format("YYYY-MM-DD")),
                  key: "selection",
                },
              ]);
              dispatch(
                setTimeSeries2({
                  end:  moment().format("YYYY-MM-DD"),
                  start:  moment(addDays(new Date(), -6)).format(
                        "YYYY-MM-DD"
                      ),
                  dateReset: resd?.timeSeries2?.dateReset,
                    dateType: resd?.timeSeries2?.dateType,
                    buttonClicked:resd?.timeSeries2?.buttonClicked,

                })
              );  
              
            }
            else if(resd?.timeSeries2?.dateReset == "1D" ){
              setState([
                {
                  startDate:  new Date(moment().format("YYYY-MM-DD")),
                  endDate:  new Date(moment().format("YYYY-MM-DD")),
                  key: "selection",
                },
              ]);
              dispatch(
                setTimeSeries2({
                  end:  moment().format("YYYY-MM-DD"),
                  start: moment().format("YYYY-MM-DD"),
                  dateReset: resd?.timeSeries2?.dateReset,
                    dateType: resd?.timeSeries2?.dateType,
                    buttonClicked:resd?.timeSeries2?.buttonClicked,

                })
              );  
              
            }
            else if(resd?.timeSeries2?.dateReset == "3M" ){
              setState([
                {
                  startDate:  new Date( moment(addMonths(new Date(), -3)).format(
                        "YYYY-MM-DD"
                      ),),
                  endDate:  new Date(moment().format("YYYY-MM-DD")),
                  key: "selection",
                },
              ]);
              dispatch(
                setTimeSeries2({
                  end:  moment().format("YYYY-MM-DD"),
                  start:  moment(addMonths(new Date(), -3)).format(
                        "YYYY-MM-DD"
                      ),
                  dateReset: resd?.timeSeries2?.dateReset,
                    dateType: resd?.timeSeries2?.dateType,
                    buttonClicked:resd?.timeSeries2?.buttonClicked,

                })
              );  
              
            }
            else if(resd?.timeSeries2?.dateReset == "6M" ){
              setState([
                {
                  startDate:  new Date( moment(addMonths(new Date(), -6)).format(
                        "YYYY-MM-DD"
                      ),),
                  endDate:  new Date(moment().format("YYYY-MM-DD")),
                  key: "selection",
                },
              ]);
              dispatch(
                setTimeSeries2({
                  end:  moment().format("YYYY-MM-DD"),
                  start: moment(addMonths(new Date(), -6)).format(
                        "YYYY-MM-DD"
                      ),
                  dateReset: resd?.timeSeries2?.dateReset,
                    dateType: resd?.timeSeries2?.dateType,
                    buttonClicked:resd?.timeSeries2?.buttonClicked,

                })
              );  
              
            }

           else if(resd?.timeSeries2?.dateReset == "1M" || !resd?.timeSeries2?.dateReset ){
              setState([
                {
                  startDate: new Date(moment(addDays(new Date(), -29)).format(
                        "YYYY-MM-DD"
                      ),),
                  endDate: new Date(moment().format("YYYY-MM-DD")),
                  key: "selection",
                },
              ]);
              dispatch(
                setTimeSeries2({
                  end: moment().format("YYYY-MM-DD"),
                  start: moment(addDays(new Date(), -29)).format(
                        "YYYY-MM-DD"
                      ),
                  dateType: resd?.timeSeries2?.dateType,
                    dateReset: resd?.timeSeries2?.dateReset,
                    buttonClicked:resd?.timeSeries2?.buttonClicked,
                })
              );  
              
            }
            
 } }
         
         
            // onChange={()=>{
            //   setState([
            //     {
            //       startDate: new Date(moment(firstDay).format("YYYY-MM-DD")),
            //       endDate: new Date(moment(new))
            //     }
            //   ])
            // }}
            className="btn bg-gradient-secondary m-0 me-2"
          >
            Reset
            <i className="material-icons opacity-10">settings_backup_restore</i>
          </button>
          <button
            type="button"
            id="datepickerSumbit"
            onClick={() => {
              dispatch(setButtonClicked());
              // dispatch(
              //   setTimeSeries1({
              //     start: moment(state[0].startDate).format("YYYY-MM-DD"),
              //     end: moment(state[0].endDate).format("YYYY-MM-DD"),
              //     dateType: resd?.timeSeries2?.dateType,
              //     buttonClicked: !resd?.timeSeries2?.buttonClicked,
              //   })
              // );
              // dispatch(setButtonClicked());
              dispatch(
                setTimeSeries2({
                  start: moment(state[0].startDate).format("YYYY-MM-DD"),
                  end: moment(state[0].endDate).format("YYYY-MM-DD"),
                  dateType: resd?.timeSeries2?.dateType,
                  buttonClicked: !resd?.timeSeries2?.buttonClicked,
                })
              );
            }}
            className="btn bg-gradient-primary m-0"
          >
            Submit
            <i className="material-icons opacity-10">arrow_right_alt</i>
          </button>
        </div>
      </div>
    </>
  );
}
